import React, { useState } from 'react';
import {
  ArrayField,
  AutocompleteInput,
  BooleanField,
  Button,
  ChipField,
  Datagrid,
  EditButton,
  List,
  NumberField,
  ReferenceField,
  ReferenceInput,
  Show,
  SimpleShowLayout,
  TextField,
  TopToolbar,
  useNotify,
  useRedirect,
  useRefresh,
} from 'react-admin';
import { ShowSplitter } from "ra-compact-ui";
import { useMutation as apolloUseMutation } from "@apollo/client/react/hooks/useMutation";
import { gql } from "@apollo/react-hooks";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";


import { Form } from 'react-final-form'

const nameLikeSearch = (n) => {
  if (n && n.length >= 2) {
    return {
      name__like: n,
    }
  }
}

export const FeatureFlagList = props => (
  <List {...props} >
    <Datagrid rowClick="show">
      <TextField source="id" />
      <TextField source="code" />
      <TextField source="displayName" />
    </Datagrid>
  </List>
);

const FeatureFlagShowActions = ({ basePath, data, record }) => (
  <TopToolbar>
    <EditButton basePath={basePath} label="Edit" record={data} />
    <EnableCompanyFeatureFlag basePath={basePath} record={data} />
  </TopToolbar>
);


const EnableCompanyFeatureFlag = ({ record }) => {
  const [open, setOpen] = useState(false);
  const redirectTo = useRedirect();
  const notify = useNotify();
  const refresh = useRefresh();


  const [enableFeatureFlag] = apolloUseMutation(gql`
      mutation Enable($companyId: Int!, $feautureFlagId: Int!, $projectId: Int!) {
          enableFeatureFlagForCompanyProject(
              companyId: $companyId
              projectId: $projectId
              featureFlagId: $feautureFlagId
          ) {
              id
          }
      }
  `);

  const handleEnable = async (args) => {
    try {
      await enableFeatureFlag({
        variables: {
          "companyId": args.companyId,
          "projectId": args.projectId,
          "feautureFlagId": record.id,
        }
      });
      notify('Saved');
      redirectTo(`/FeatureFlag/${record.id}/show`);
      refresh();
      setOpen(false)
    } catch (e) {
      notify(e.toString());
    }
  }


  return (
    <>
      <Button label={'Add new flag for company/project'} variant={'outlined'} color="primary" onClick={() => setOpen(true)}/>
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        fullWidth
        maxWidth="md"
      >
        <DialogTitle>Enable feature for a company and project</DialogTitle>
        <DialogContent>
          <Form onSubmit={handleEnable} render={({ handleSubmit }) => (
            <div>
              <ReferenceInput label="Project" source="projectId" reference="Project" filterToQuery={nameLikeSearch} perPage={100} alwaysOn>
                <AutocompleteInput source="name"/>
              </ReferenceInput>
              <ReferenceInput label="Company" source="companyId" reference="Company" filterToQuery={nameLikeSearch} perPage={100} alwaysOn>
                <AutocompleteInput source="name"/>
              </ReferenceInput>
              <Button label="Create" onClick={handleSubmit}/>
            </div>
          )}>
          </Form>
        </DialogContent>
      </Dialog>
    </>
  );
}

const EnableDisableButton = ({ record, enable, ...rest }) => {
  const redirectTo = useRedirect();
  const notify = useNotify();
  const refresh = useRefresh();
  const [enableFeatureFlag] = apolloUseMutation(gql`
      mutation Enable($companyId: Int!, $feautureFlagId: Int!, $projectId: Int!) {
          enableFeatureFlagForCompanyProject(
              companyId: $companyId
              projectId: $projectId
              featureFlagId: $feautureFlagId
          ) {
              id
          }
      }
  `);
  const [disableFeatureFlag] = apolloUseMutation(gql`
      mutation Enable($companyId: Int!, $feautureFlagId: Int!, $projectId: Int!) {
          disableFeatureFlagForCompanyProject(
              companyId: $companyId
              projectId: $projectId
              featureFlagId: $feautureFlagId
          ) {
              id
          }
      }
  `);


  const handleEnableDisable = async () => {
    const func = enable ? enableFeatureFlag : disableFeatureFlag;
    try {
      await func({
        variables: {
          "companyId": record.company.id,
          "projectId": record.project.id,
          "feautureFlagId": record.featureFlag.id,
        }
      });
      notify('Saved');
      refresh();
    } catch (e) {
      notify(e.toString());
    }
  }
  return <Button {...rest} onClick={handleEnableDisable}/>
}

export const FeatureFlagShow = props => {


  return (
    <Show {...props} actions={<FeatureFlagShowActions/>}>
      <ShowSplitter
        leftSideProps={{
          md: 4,
          component: 'div'
        }}
        rightSideProps={{
          md: 8
        }}
        leftSide={(
          <SimpleShowLayout>
            <TextField source="id"/>
            <TextField source="code"/>
            <TextField source="displayName"/>
          </SimpleShowLayout>
        )}
        rightSide={(
          <SimpleShowLayout>
            <ArrayField source={'featureFlagCompanyProjects'}>
              <Datagrid>
                <NumberField source={'id'}/>
                <ReferenceField label="Project" reference="Project" source="project.id" link="show">
                  <ChipField source="name"/>
                </ReferenceField>
                <ReferenceField label="Company" reference="Company" source="company.id" link="show">
                  <ChipField source="name"/>
                </ReferenceField>
                <BooleanField source='enabled'/>
                <EnableDisableButton label={"disable"} enable={false}/>
                <EnableDisableButton label={"enable"} enable/>
              </Datagrid>
            </ArrayField>
          </SimpleShowLayout>
        )}
      />
    </Show>
  );
};
